import { StorageIds } from '../constants/storage'

export const getStorageFavoritePageIds = () => {
  const favoritePageIds = localStorage.getItem(StorageIds.favoritePageIds)

  return favoritePageIds && JSON.parse(favoritePageIds)
}

export const clearStorageFavoritePageIds = () => {
  localStorage.removeItem(StorageIds.favoritePageIds)
}
